import { QUERY_LIST, updateList } from '../../../integrations/list'
import { call, put, select, take, takeEvery } from 'redux-saga/effects'
import { prepareAscentForQuery, prepareDistanceForQuery } from '../helpers'
import { resetLocation, updateGeonameInfo } from '../../../integrations/geolocation'
import { route } from '../../../api'
import { MAP_BOUNDS_UPDATE } from '@bikemap/js/integrations/map/actions'
import { INITIAL_BOUNDLESS_QUERY } from '../actions'

function* queryRoutes() {
    // Get all relevant data from the current state
    const {
        q, distance, ascent, categories, surfaces, onlyLoop,
    } = yield select(state => state.filters)
    const primaryFilters = yield select(state => state.primaryFilters) || {}
    const { page, pageSize, sort, order } = yield select(state => state.results)
    const bounds = yield select(state => state.mapViewport.bounds)
    const location = yield select(state => state.geolocation.location)

    const params = {
        q,
        categories,
        surfaces,
        onlyLoop,
        distance: prepareDistanceForQuery(distance),
        ascent: prepareAscentForQuery(ascent),
        page,
        sort,
        order,
        pageSize,
        location,
        bounds,
        ...primaryFilters,
    }

    if (!bounds) {
        params.center = yield select(state => state.mapViewport.center)
    }

    try {
        // Call search endpoint and update results
        /** @type {import("../../../api/services/RouteApiService").RouteListResult} */
        const res = yield call(route.list, params)
        const { geoname, bounds, count, results, entities } = res

        if (params.location) {
            // Request included a geoname location
            if (geoname && bounds) {
                // Geoname lookup successful, so update info
                yield put(updateGeonameInfo(geoname, bounds))
            } else {
                // No geoname found, so we drop the location filter
                yield put(resetLocation())
            }
        }

        yield put(updateList(results, page, count, entities))

        // Then scroll to top of page
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        })
    } catch (error) {
        yield call(console.error, error.message)
    }
}

export default function* searchQuerySaga() {
    // Wait with the first query until we have bounds
    yield take([MAP_BOUNDS_UPDATE, INITIAL_BOUNDLESS_QUERY])
    yield call(queryRoutes)

    // Then call API on every list query
    yield takeEvery(QUERY_LIST, queryRoutes)
}
